import { FC } from "react"
import { SystemsManualList } from "../../../../module/systems/containers/manual"

export const SystemsManualFAQPage: FC = () => <SystemsManualList />
